import React, { useState, useContext } from 'react';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import styles from '../../css/components/common/socialMediaLinkListContainer.css';
import SocialMediaLinkListLegacy from '../common/SocialMediaLinkListLegacy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UskLabelSmall from './UskLabelSmall';

function SocialMediaLinkListContainer({ gameId }) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const [isShown, setShown] = useState(true);
	const { t } = useTranslation('translation');

	const handleToggle = () => {
		setShown(!isShown);
	};

	const showUskLabel = onelpsParams.uskLabel?.show && onelpsParams.uskLabel?.socialMediaBar && onelpsParams.country === 'DE';

	return (
		<>
			<div
				className={`${styles.socialMediaLinkListContainer} ${styles[gameId]}`}
				data-testid="socialMediaLinkListContainer">

				<div className={`${styles.content}`}>

					<p className={styles.caption}>{t('social.caption')}</p>

					{isShown && (
						<SocialMediaLinkListLegacy />
					)}

					<a
						onClick={handleToggle}
						data-testid='toggle'
						className={`${styles.toggle} ${isShown ? styles.open : styles.closed}`}>
					</a>
				</div>
				{showUskLabel && <UskLabelSmall />}
			</div>

		</>
	);
}

SocialMediaLinkListContainer.propTypes = {
	gameId: PropTypes.string.isRequired,
};

export default SocialMediaLinkListContainer;
